import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "../locales/duck";
import controllerPlanes from "../planes/duck";
import controllerReservas from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import SelectInputAutocomplete from "../utils/SelectInputAutocomplete";
import "react-phone-input-2/lib/style.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Select2, Text } = Inputs;

function CrearReservaHorarios({ history, match }) {
  const dispatch = useDispatch();

  const modelLocal = useSelector((state) => state.localById);
  const modelPrimerDia = useSelector((state) => state.primerDiaDisponible);
  const modelHorarios = useSelector((state) => state.horariosEntreFechas);
  const modelReserva = useSelector((state) => state.generarReservas);
  const modelName = useSelector((state) => state.suscripcionByCi);

  const [local, setLocal] = useState(null);
  const [nombre, setNombre] = useState("");
  const [ci, setCi] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [servicioPadre, setServicioPadre] = useState(null);
  const [servicioPadreNombre, setServicioPadreNombre] = useState(null);
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState(null);
  const [horarioId, setHorarioId] = useState(null);
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [serviciosOptions, setServiciosOptions] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [servicioNombre, setServicioNombre] = useState(null);
  const [horarioSelected, setHorarioSelected] = useState(null);
  const [profesionalNombre, setProfesionalNombre] = useState(null);
  const [minMonth, setMinMonth] = useState(null);
  const [minYear, setMinYear] = useState(null);
  const [minDay, setMinDay] = useState(null);
  const [maxMonth, setMaxMonth] = useState(null);
  const [maxYear, setMaxYear] = useState(null);
  const [maxDay, setMaxDay] = useState(null);
  const [dias, setDias] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [seguro, setSeguro] = useState(null);
  const [seguroOptions, setSeguroOptions] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [clienteOptions, setClienteOptions] = useState([]);
  const [documentoSearch, setDocumentoSearch] = useState("");
  const [documentFound, setDocumentFound] = useState(false);

  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesional, setProfesional] = useState(null);
  const [excludedDates, setExcludedDates] = useState([]);
  const [horarioOptions, setHorarioOptions] = useState([]);
  const [horario, setHorario] = useState(null);

  const [localId, setLocalId] = useState(
    match.params.organizacion ? match.params.organizacion : null
  );

  useEffect(() => {
    if(cliente != null) {
      const { nombre, telefono, direccion, ruc } = cliente.value;
      setNombre(nombre);
      setTelefono(telefono);
      setDireccion(direccion);
      setCi(ruc);
    }
  }, [cliente])

  useEffect(() => {
    const data = modelName?.data?.data;
    const error = modelName?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerPlanes.duckSuscripcionByCi.actions.clear());
    }
    if (data) {
      if (data.data) {
        setNombre(data.data.nombrePersona);
        setCi(documentoSearch);
        setDocumentFound(true);
      } else {
        setDocumentFound(false);
        setCi(documentoSearch);
      }

      dispatch(controllerPlanes.duckSuscripcionByCi.actions.clear());
    }
  }, [modelName]);

  useEffect(() => {
    dispatch(controller.localByIdThunk(localId));

    const horarioSelectedAux = localStorage.getItem("horarioSelected");
    const subcategoriaAux = localStorage.getItem("subcategoria");
    const servicioAux = localStorage.getItem("servicio");
    const profesionalAux = localStorage.getItem("profesional");

    setHorarioSelected(JSON.parse(horarioSelectedAux));
    setServicioPadreNombre(JSON.parse(subcategoriaAux));
    setServicioNombre(JSON.parse(servicioAux));
    setProfesionalNombre(JSON.parse(profesionalAux));
  }, []);

  useEffect(() => {
    const data = modelReserva?.data?.data;
    const error = modelReserva?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.generarReservasDuck.actions.clear());
    }
    if (data && data.data) {
      localStorage.removeItem("horarioSelected");
      localStorage.removeItem("subcategoria");
      localStorage.removeItem("servicio");
      localStorage.removeItem("profesional");
      history.push(`/calendarioLocal/${match.params.organizacion}`);

      dispatch(controllerReservas.generarReservasDuck.actions.clear());
    }
  }, [modelReserva]);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      setLocal(data.data);
      console.log("LOCAL: ", local);

      if (data.data.campoSeguro === "SI" && data.data.seguros) {
        const seguroOpciones = data.data.seguros.map((row) => ({
          value: row._id,
          label: row.nombre,
        }));
        setSeguroOptions(seguroOpciones);
      }

      const subcategoriaOptions = data.data.subCategorias.map((row) => ({
        label: row.nombre,
        value: row.id,
      }));
      setServiciosPadreOptions(subcategoriaOptions);
      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    const data = modelPrimerDia?.data?.data;
    const error = modelPrimerDia?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.primerDiaDisponibleDuck.actions.clear());
    }
    if (data) {
      const daysInLastMonth = moment(
        data.data.dia[0].lastYear + "-" + data.data.dia[0].lastMonth,
        "YYYY-MM"
      ).daysInMonth();
      if (!minMonth && !minYear && !minDay) {
        setMinDay(data.data.dia[0].dia);
        setMinMonth(data.data.dia[0].mes);
        setMinYear(data.data.dia[0].anho);

        setMaxDay(daysInLastMonth);
        setMaxMonth(data.data.dia[0].lastMonth);
        setMaxYear(data.data.dia[0].lastYear);
      }
      setMonth(data.data.dia[0].mes);
      setYear(data.data.dia[0].anho);

      dispatch(
        controllerReservas.getHorariosEntreFechasThunk(
          data.data.dia[0].anho +
            "-" +
            data.data.dia[0].mes +
            "-" +
            data.data.dia[0].dia,
          data.data.dia[0].lastYear +
            "-" +
            data.data.dia[0].lastMonth +
            "-" +
            daysInLastMonth,
          profesional,
          servicio
        )
      );

      dispatch(controllerReservas.primerDiaDisponibleDuck.actions.clear());
    }
  }, [modelPrimerDia]);

  useEffect(() => {
    const data = modelHorarios?.data?.data;
    const error = modelHorarios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerReservas.horariosEntreFechasDuck.actions.clear());
    }
    if (data) {
      setDias(data.data);
      const diasDisponibles = Object.keys(data.data);

      const daysInLastMonth = moment(
        year + "-" + month,
        "YYYY-MM"
      ).daysInMonth();
      const arrayFinal = [];
      for (let i = 1; i <= daysInLastMonth; i++) {
        const formattedMonth =
          Number(month) > 9 ? Number(month) : "0" + Number(month);
        const formattedDay = Number(i) > 9 ? Number(i) : "0" + Number(i);
        const formatted = year + "-" + formattedMonth + "-" + formattedDay;

        if (!diasDisponibles.includes(formatted)) {
          const fechaAProcesar = new Date(year, month - 1, i);
          arrayFinal.push(fechaAProcesar);
        }
      }

      setExcludedDates(arrayFinal);

      dispatch(controllerReservas.horariosEntreFechasDuck.actions.clear());
    }
  }, [modelHorarios]);

  function submit() {
    if (
      !nombre ||
      !profesionalNombre ||
      !servicioNombre ||
      !horarioSelected ||
      !servicioPadreNombre ||
      (!ci && local.isIntegracionActivada)
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      (local.categoriaId === "60f7f0a397887a90e7bfed2b" ||
        local.categoriaId === "60f7ed6a559e075075ed055a") &&
      !ci
    ) {
      alert("Por favor ingrese el numero de documento");
      return;
    }

    const servicioSelected = local.servicios.filter(
      (elem) => elem.id === servicioNombre.value
    );
    const profesionalSelected = local.profesionales[profesionalNombre.id];

    const fechaSplitted = moment(horarioSelected.ts)
      .format("YYYY-MM-DD")
      .split("-");
    // const horarioSelected = horarioOptions.filter(
    //   (elem) => elem.value === horario
    // );
    const fechaFinal =
      moment(horarioSelected.ts).format("YYYY-MM-DD") +
      " " +
      horarioSelected.hora;

    let seguroNombre = null;

    if (seguro) {
      seguroNombre = seguroOptions.filter((item) => item.value === seguro);
    }
    let data = {
      origen: "ADMIN",
      usuarioId: null,
      ci: ci,
      nombre: nombre,
      categoriaId: local.categoriaId,
      direccion: direccion,
      telefono: telefono,
      ciudad: ciudad,
      localId: match.params.organizacion,
      profesionalId: profesionalSelected.id, //restaurante null
      servicioId: servicioNombre.value,
      subCategoriaId: servicioPadreNombre.value,
      duracion: servicioSelected[0].duracion,
      maxPersonas: servicioSelected[0].maxPersonas,
      anho: fechaSplitted[0],
      mes: Number(fechaSplitted[1]),
      dia: Number(fechaSplitted[2]),
      fecha: fechaFinal,
      hora: horarioSelected.hora,
      horarioId: horarioSelected._id,
      ambiente: 0, // peluqueria null
      validaPara: 1, //peluqueria null
      metodoPago: 10,
      servicioNombre: servicioSelected[0].nombre,
      categoriaNombre: local.categoriaNombre,
      profesionalNombre: profesionalSelected.nombre,
      localNombre: local.nombre,
      tiempoCancelar: local.tiempoCancelar,
      seguroMedicoId: seguro,
      seguroNombre:
        seguroNombre && seguroNombre[0] ? seguroNombre[0].label : null,
      nombrePaciente: nombre,
    };

    dispatch(controllerReservas.generarReservasThunk({ reservas: [data] }));
  }

  const getDateUtcWithHour = (fecha) => {
    const day = fecha
      ? moment(fecha).utc().format("YYYY-MM-DD HH:mm")
      : moment().utc().format("YYYY-MM-DD HH:mm");
    return day;
  };

  function search() {
    if (!documentoSearch) {
      alert("Por favor proporcione un documento");
      return;
    }

    let data = {
      ci: documentoSearch,
      localId: match.params.organizacion,
    };

    dispatch(controllerPlanes.getSuscripcionByCiThunk(data));
  }

  return (
    <Content title="Crear reserva" browserTitle="Crear reserva" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Crear reserva"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(
                      `/calendarioLocal/${match.params.organizacion}`
                    );
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelReserva.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelReserva.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />
            {local && local.categoriaId === "60f7f0a397887a90e7bfed2b" && (
              <div style={{ marginBottom: 30 }}>
                <Text
                  labelPosition="above"
                  size="sm"
                  inputType="number"
                  label={<Etiqueta texto="Documento" obligatorio={true} />}
                  value={documentoSearch}
                  onChange={(evt) => setDocumentoSearch(evt.target.value)}
                />
                <Button
                  type="primary"
                  text="Buscar"
                  disabled={modelName.loading}
                  onClick={() => search()}
                />
              </div>
            )}
            {local?.isIntegracionActivada ? <SelectInputAutocomplete
                value={cliente}
                setValue={setCliente}
                body={{ localId }} 
              /> : null}
            {local &&
            local.campoSeguro &&
            local.seguros &&
            local.seguros.length > 0 ? (
              <SelectInput
                value={seguro}
                setValue={setSeguro}
                label="Seguro"
                options={seguroOptions}
              />
            ) : null}
            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              disabled={local && local.categoriaId === "60f7f0a397887a90e7bfed2b" && documentFound}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Ciudad"
              value={ciudad}
              onChange={(evt) => setCiudad(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Direccion"
              value={direccion}
              onChange={(evt) => setDireccion(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label={
                <Etiqueta
                  texto="Documento"
                  obligatorio={
                    local &&
                    (local.categoriaId === "60f7f0a397887a90e7bfed2b" ||
                      local.categoriaId === "60f7ed6a559e075075ed055a" || 
                        local?.isIntegracionActivada)
                      ? true
                      : false
                  }
                />
              }
              value={ci}
              disabled={local && local.categoriaId === "60f7f0a397887a90e7bfed2b"}
              onChange={(evt) => setCi(evt.target.value)}
            />

            <Text
              labelPosition="above"
              size="sm"
              label="Telefono (981XXXXXX)"
              value={telefono}
              onChange={(evt) => setTelefono(evt.target.value)}
            />

            {servicioPadreNombre &&
            servicioNombre &&
            profesionalNombre &&
            horarioSelected ? (
              <>
                <text>
                  <strong>{`Subcategoria: ${servicioPadreNombre.label}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Servicio: ${servicioNombre.label}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Profesional: ${profesionalNombre.nombre}`}</strong>
                </text>
                <br />
                <text>
                  <strong>{`Fecha: ${getDateUtcWithHour(
                    horarioSelected.ts
                  )}`}</strong>
                </text>
                <br />
              </>
            ) : null}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default CrearReservaHorarios;
